import React, { useMemo } from 'react';
import { Typography } from '~/UIKit';
import { FITOGRAM_BLUE_FADED_9, ICON_WARING } from '~/Constants/Colors.constants';
import { FormikErrors } from 'formik';
import { FONT_SIZE_SMALLISH } from '~/Constants/UI.constants';
import { WarningRounded } from '@mui/icons-material';
import { makeStyles } from '~/UIKit/Style';

const useStyles = makeStyles(() => ({
  root: {
    background: FITOGRAM_BLUE_FADED_9,
    fontSize: FONT_SIZE_SMALLISH,
    margin: '10px 0',
    padding: 10,
    display: 'flex',
    alignItems: 'center',
  },
  icon: {
    marginRight: 10,
    color: ICON_WARING,
  },
}));

export const FormErrors = <T extends any>({ errors }: { errors: FormikErrors<T> }) => {
  const { classes } = useStyles();

  const items = useMemo(
    () =>
      Object.entries(errors || {}).map(([key, value]) => (
        <Typography variant="body2" key={key} dangerouslySetInnerHTML={{ __html: String(value) }} />
      )),
    [errors],
  );

  if (!items.length) {
    return null;
  }

  return (
    <div className={classes.root}>
      <WarningRounded className={classes.icon} />
      <div>{items}</div>
    </div>
  );
};
